<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <b-container>
            <b-row>
                <b-col cols="12">
                    <TextInfo :content="cms" :isArray="Array.isArray(cms)"/>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    import TextInfo from "~/components/TextInfo";
    import Breadcrumb from "~/components/Breadcrumb";
    import Sidenav from "~/components/Sidenav";
    export default{
        head() {
            return {
                title: this.title,
            }
        },
        components:{
            TextInfo,
            Breadcrumb,
            Sidenav
        },
        data: function () {
            return {
                cms: {
                    name: '',
                    text1: '',
                }
            }
        },
        computed:{
            breadcrumb(){
                let breadcrumb = [
                    {
                        name: 'Home',
                        link: '/'
                    }
                ];
                breadcrumb.push({
                    name: this.title,
                    link: null
                })
                return breadcrumb;
            },
            title() {
                let title = this.cms.title;
                try {
                    title = this.cms.name;
                    // if (typeof this.content === 'object' && Array.isArray(this.content) === false && this.cms.data.name1 !== '') {
                    //     title = this.cms.data.name1
                    // }
                } catch (e) {
                    console.error(e)
                }
                return title
            }
        },
        async asyncData({params, res, $axios, req, app, error}) {
            try {
                const cms = await $axios.$get(`api/v1/cms/?page_alias=${params.cms_page_alias}`);
                if (cms.status !== 'success') {
                    throw error({statusCode: 404});
                }
                let cms_schema = {
                    title: '',
                    data: {
                        name: '',
                        text1: ''
                    }
                }
                cms_schema = Object.assign({}, cms_schema, cms);
                if (cms_schema.data.name === '') {
                    cms_schema.data.name = cms_schema.title
                }
                return {
                    cms: cms.data
                }
            } catch (e) {
                console.error(e)
            }
        }
    }
</script>
